﻿$.fn.dxCtrlBuilderEmailStylePadding = function custom_dxCtrlBuilderEmailStylePadding(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylepadding dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStylePadding(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStylePadding = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.type == 'undefined') option.type = "padding"

    var margeGrouper = null
    function mConstruit() {
        container.empty()


        if (margeGrouper == null) margeGrouper = (option.padTop == option.padBottom && option.padLeft == option.padRight && option.padBottom == option.padLeft)

        $("<div style='display:inline-block;padding:5px;'/>").appendTo(container).dxCtrlCheckBox({
            value: margeGrouper,
            text: "Marge identique",
            onValueChanged: function (e) {
                margeGrouper = e.value
                var newValue = option.padTop + ((option.padTop.toString().length > 0) ? "px" : "")
                option.onValueChanged({
                    values: [
                        { prop: option.type + "-top", value: newValue, oldValue: option.padTop },
                        { prop: option.type + "-left", value: newValue, oldValue: option.padLeft },
                        { prop: option.type + "-right", value: newValue, oldValue: option.padRight },
                        { prop: option.type + "-bottom", value: newValue, oldValue: option.padBottom }
                    ]
                });
                option.padTop = newValue
                option.padBottom = newValue
                option.padLeft = newValue
                option.padRight = newValue
                mConstruit()
            }
        })

        if (margeGrouper) {
            var $Table = $("<table style='width:100%;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
            var dxBtDefaut = $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-text-slash",
                disabled: (option.padTop.length == 0),
                onClick: function (e) {
                    dxSliderRadius.option("value", 0)
                    dxSliderRadius.option("value", parseInt(""))
                    dxSliderRadius.repaint()

                    //option.onValueChanged({
                    //    values: [
                    //        { prop: option.type + "-top", value: "", oldValue: option.padTop },
                    //        { prop: option.type + "-left", value: "", oldValue: option.padLeft },
                    //        { prop: option.type + "-right", value: "", oldValue: option.padRight },
                    //        { prop: option.type + "-bottom", value: "", oldValue: option.padBottom }
                    //    ]
                    //});
                    //option.padTop = ""
                    //option.padBottom = ""
                    //option.padLeft = ""
                    //option.padRight = ""
                },
                onContentReady: function (e) {
                    e.element.css("opacity", ((option.padTop.length == 0) ? "0.3" : 1))
                }
            }).dxCtrlButton("instance")

            if (!option.allowDefaut) $Td.hide()
            var timeOutSlider = null
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            var dxSliderRadius = $("<div/>").appendTo($Td).dxSlider({
                min: 0,
                max: 100,
                value: parseInt(option.padTop.replace("px", "")),
                onValueChanged: function (e) {
                    window.clearTimeout(timeOutSlider)
                    timeOutSlider = window.setTimeout(function () {
                        var newValue = ((isNaN(e.value) ? "" : e.value + "px"))
                        if (newValue.toString().length == 0) {
                            dxBtDefaut.option("disabled", true)
                            dxBtDefaut.component().element().css("opacity", "0.3")
                        } else {
                            dxBtDefaut.option("disabled", false)
                            dxBtDefaut.component().element().css("opacity", "1")
                        }
                        option.onValueChanged({
                            values: [
                                { prop: option.type + "-top", value: newValue, oldValue: option.padTop },
                                { prop: option.type + "-left", value: newValue, oldValue: option.padLeft },
                                { prop: option.type + "-right", value: newValue, oldValue: option.padRight },
                                { prop: option.type + "-bottom", value: newValue, oldValue: option.padBottom }
                            ]
                        });
                        option.padTop = newValue
                        option.padBottom = newValue
                        option.padLeft = newValue
                        option.padRight = newValue

                        //var val = ((isNaN(e.value)) ? "" : e.value + "px")
                        //var newValues = mGetNewValue(val, val, val, val)
                        //option.onValueChanged(newValues);
                    }, 1000)
                },
                tooltip: {
                    enabled: true,
                    format(value) {
                        if (isNaN(value)) { return `Marge: Défaut`; }
                        else { return `Marge: ${value}px`; }
                    },
                    showMode: 'always',
                    position: 'bottom',
                },
                onContentReady: function (e) { window.setTimeout(function () { e.component.repaint() }, 0) }
            }).dxSlider("instance")
            //$("<div style='width:200px'/>").appendTo(container).dxCtrlWidgetNumber({
            //    label: "Haut/bas/gauche/droite",
            //    placeholder: "Défaut",
            //    noNull: !option.allowDefaut,
            //    value: ((option.padTop.toString().length == 0) ? null : option.padTop),
            //    onValueChanged: function (e) {
            //        var newValue = ((e.value == null) ? "" : e.value);
            //        newValue += ((newValue.toString().length > 0) ? "px" : "")
            //        option.onValueChanged({
            //            values: [
            //                { prop: option.type + "-top", value: newValue, oldValue: option.padTop },
            //                { prop: option.type + "-left", value: newValue, oldValue: option.padLeft },
            //                { prop: option.type + "-right", value: newValue, oldValue: option.padRight },
            //                { prop: option.type + "-bottom", value: newValue, oldValue: option.padBottom }
            //            ]
            //        });
            //        option.padTop = newValue
            //        option.padBottom = newValue
            //        option.padLeft = newValue
            //        option.padRight = newValue
            //    }
            //})
        } else {
            var $Table = $("<table style='width:280px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;padding:0 20px 5px 20px;' colspan='2'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Haute",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.padTop.length == 0) ? null : option.padTop),
                onValueChanged: function (e) {
                    var newValue = ((e.value == null) ? "" : e.value);
                    newValue += ((newValue.toString().length > 0) ? "px" : "")
                    option.onValueChanged({ values: [{ prop: option.type + "-top", value: newValue, oldValue: option.padTop }] });
                    option.padTop = newValue
                }
            })
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;padding-right:5px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Gauche",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.padLeft.length == 0) ? null : option.padLeft),
                onValueChanged: function (e) {
                    var newValue = ((e.value == null) ? "" : e.value);
                    newValue += ((newValue.toString().length > 0) ? "px" : "")
                    option.onValueChanged({ values: [{ prop: option.type + "-left", value: newValue, oldValue: option.padLeft }] });
                    option.padLeft = newValue
                }
            })
            var $Td = $("<td style='width:50%;padding-left:5px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Droite",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.padRight.length == 0) ? null : option.padRight),
                onValueChanged: function (e) {
                    var newValue = ((e.value == null) ? "" : e.value);
                    newValue += ((newValue.toString().length > 0) ? "px" : "")
                    option.onValueChanged({ values: [{ prop: option.type + "-right", value: newValue, oldValue: option.padRight }] });
                    option.padRight = newValue
                }
            })
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;padding:5px 20px 0 20px;' colspan='2'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Basse",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.padBottom.length == 0) ? null : option.padBottom),
                onValueChanged: function (e) {
                    var newValue = ((e.value == null) ? "" : e.value);
                    newValue += ((newValue.toString().length > 0) ? "px" : "")
                    option.onValueChanged({ values: [{ prop: option.type + "-bottom", value: newValue, oldValue: option.padBottom }] });
                    option.padBottom = newValue
                }
            })
        }
    }

    this.element = function () { return container }

    mConstruit();
}